import { primary, secondary, headerBg, footerBg, black } from './colors'
const theme = {
  color: {
    primary,
    secondary,
    headerBg,
    footerBg,
    black,
  },
}

export default theme
